  const firebase = require("firebase/app");
  import 'firebase/firebase-messaging'
import "./registerServiceWorker";

require("firebase/auth");
require("firebase/firestore");
require("firebase/storage");

const config = {
    apiKey: "AIzaSyDhT9Rf9AURv4H4k5fU93u-5Lc5w-fsfUU",
    authDomain: "facey-a2397.firebaseapp.com",
    databaseURL: "https://facey-a2397.firebaseio.com",
    projectId: "facey-a2397",
    storageBucket: "facey-a2397.appspot.com",
    messagingSenderId: "712648606114",
    appId: "1:712648606114:web:ad0c2b7b233b7f4f",
    measurementId: "G-05YKVRH5LR"
  };

  
firebase.initializeApp(config);


let messaging;

const FirebaseMessaging = {
  init() {
    if (!messaging) {
      // firebase.initializeApp(config);
      messaging = firebase.messaging();
      messaging.usePublicVapidKey("BKUJscoY4SqVs_7QPA4lwtBtXPcqyaqkL5A7HROIMsBIOupn7W0kSw97FZVxMqG5QdkKux9ipNPUq8HHczfCjc4"); // 1. Generate a new key pair
     
    }
  },

  initServiceWorker(registration) {
    this.init();
    messaging.useServiceWorker(registration);
    messaging.requestPermission().then(() => {
      console.log('Notification permission granted.');
    
      // Get Token
      messaging.getToken().then((token) => {
        console.log(token)
      })

      messaging.onMessage(payload => {
        console.log("Message received. ", payload);
        const { title, ...options } = payload.notification;
      });

      messaging.setBackgroundMessageHandler(payload => {
        const notification = JSON.parse(payload.data.notification);
        const notificationTitle = notification.title;
        const notificationOptions = {
          body: notification.body
        };
        //Show the notification :)
        return self.registration.showNotification(
          notificationTitle,
          notificationOptions
        );
      });
    }).catch((err) => {
      console.log('Unable to get permission to notify.', err);
    });
    if (registration.active) {
      registration.active.postMessage({
        action: "initializeFirebase",
        payload: { config: config },
      });
    }
  }
};

// messaging.usePublicVapidKey("BKUJscoY4SqVs_7QPA4lwtBtXPcqyaqkL5A7HROIMsBIOupn7W0kSw97FZVxMqG5QdkKux9ipNPUq8HHczfCjc4"); // 1. Generate a new key pair

// // Request Permission of Notifications
// messaging.requestPermission().then(() => {
//   console.log('Notification permission granted.');

//   // Get Token
//   messaging.getToken().then((token) => {
//     console.log(token)
//   })
// }).catch((err) => {
//   console.log('Unable to get permission to notify.', err);
// });

const db = firebase.firestore();
const auth = firebase.auth();
const storage = firebase.storage();


export {firebase, db, auth, storage, messaging, FirebaseMessaging}